<h2>Product Barcode Assignment</h2>
<div class="px-2 py-3 contents h-full max-h-80" *ngIf="isLoadProductBarcodeMasterDataSource">
    <div class="mapping-grid-container shadow-lg">
        <dx-data-grid
            #productBarcodeMasterGrid
            id="productBarcodeMasterGrid"
            [allowColumnResizing]="true"
            [columnResizingMode]="'widget'"
            [allowColumnReordering]="true"
            [dataSource]="productBarcodeMasterDataSource"
            [showBorders]="true"
            [columnAutoWidth]="true"
            [remoteOperations]="true"
            [hoverStateEnabled]="true"
            [(selectedRowKeys)]="productBarcodeMasterGridSelectedRowMap"
            (onSelectionChanged)="selectionProductBarcodeMasterChangedHandler()"
            (onContentReady)="onReady($event)"
            (onContextMenuPreparing)="productBarcodeMasterDataGridContextMenu($event)"
            (onRowExpanding)="onRowExpanding($event)"
            (onRowExpanded)="onRowExpanded($event)"
            keyExpr="ProductBarcodeId"
        >
            <dxo-state-storing
                    [enabled]="true"
                    type="custom"
                    [customLoad]="loadProductBarcodeMasterState"
                    [customSave]="saveProductBarcodeMasterState"
            ></dxo-state-storing>
            <dxo-load-panel
                    [enabled]="false"
                    shadingColor="rgba(0,0,0,0.4)"
                    [showIndicator]="true"
                    [showPane]="true"
                    [shading]="true">
            </dxo-load-panel>
            <dxo-filter-panel [visible]="true"></dxo-filter-panel>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-pager
                    [visible]="true"
                    [allowedPageSizes]="[5, 10, 25, 50, 100]"
                    displayMode="compact"
                    [showPageSizeSelector]="true"
                    [showNavigationButtons]="false"
            >
            </dxo-pager>
            <dxo-paging [pageSize]="5"></dxo-paging>
            <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>
            <dxo-selection mode="single"></dxo-selection>
            <dxo-column-chooser [enabled]="true" mode="dragAndDrop"></dxo-column-chooser>
            <dxi-column dataField="ProductBarcodeId" [allowHeaderFiltering]="false" [width]="140" caption="Product Barcode Id" [customizeText]="customizeProductBarcodeId"></dxi-column>
            <dxi-column caption="Action" cellTemplate="action" alignment="center" [allowHeaderFiltering]="false"></dxi-column>
            <dxi-column dataField="Barcode">
                <dxo-header-filter [dataSource]="barcodeHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="QuantityMultiplier">
                <dxo-header-filter [dataSource]="quantityMultiplierHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="ProductMasterId">
                <dxo-header-filter [dataSource]="productMasterIdHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column caption="Inconsistencies">
                <dxi-column dataField="MultipleBarcodeAssignmentsExist" [allowHeaderFiltering]="false"></dxi-column>
                <dxi-column dataField="MultipleBarcodeAssignmentsCount" [allowHeaderFiltering]="false"></dxi-column>
                <dxi-column dataField="InconsistentServiceAndProductMappingsExist" [allowHeaderFiltering]="false"></dxi-column>
                <dxi-column dataField="InconsistentServiceAndProductMappingsCount" [allowHeaderFiltering]="false"></dxi-column>
            </dxi-column>
            <dxi-column caption="Data auditing">
                <dxi-column dataField="CreatedByUserFullNameSortableOrPrincipalName" caption="Created By">
                    <dxo-header-filter [dataSource]="createdByUserFullNameSortableOrPrincipalNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="CreatedByUserId" [visible]="false" [allowHeaderFiltering]="false"></dxi-column>
                <dxi-column dataField="CreatedOn" dataType="date" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon">
                    <dxo-header-filter [dataSource]="createdOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ModifiedByUserFullNameSortableOrPrincipalName" caption="Modified By">
                    <dxo-header-filter [dataSource]="modifiedByUserFullNameSortableOrPrincipalNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ModifiedByUserId" [visible]="false" [allowHeaderFiltering]="false"></dxi-column>
                <dxi-column dataField="ModifiedOn" dataType="date" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon">
                    <dxo-header-filter [dataSource]="modifiedOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ReviewedByUserFullNameSortableOrPrincipalName" caption="Reviewed By">
                    <dxo-header-filter [dataSource]="reviewedByUserFullNameSortableOrPrincipalNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ReviewedByUserId" [visible]="false" [allowHeaderFiltering]="false"></dxi-column>
                <dxi-column dataField="ReviewedOn" dataType="date" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon">
                    <dxo-header-filter [dataSource]="reviewedOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
            </dxi-column>
            <dxi-column dataField="MappingModeName" caption="Mapping Mode Name" [allowHeaderFiltering]="false" [allowFiltering]="false">
            </dxi-column>
            <dxi-column dataField="MappingModeId" caption="Mapping Mode" [alignment]="'left'">
                <dxo-header-filter [dataSource]="mappingModeNameHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column caption="Mapped To">
                <dxi-column dataField="Active" [visible]="false" [allowHeaderFiltering]="false"></dxi-column>
                <dxi-column dataField="BrandName" [visible]="false" caption="Brand">
                    <dxo-header-filter [dataSource]="brandNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="CategoryName" [visible]="false" caption="Category">
                    <dxo-header-filter [dataSource]="categoryNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="CompanyName" [visible]="false" caption="Company">
                    <dxo-header-filter [dataSource]="companyNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="MasterBrandName" [visible]="false" caption="Master Brand">
                    <dxo-header-filter [dataSource]="masterBrandNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ProductName" [visible]="false" caption="Product">
                    <dxo-header-filter [dataSource]="productNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="SubBrandName" [visible]="false" caption="Sub-Brand">
                    <dxo-header-filter [dataSource]="subBrandNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ProductSizeOnLabel" [visible]="false" caption="Product Size"></dxi-column>
                <dxi-column dataField="SubcategoryFormName" [visible]="false" caption="Subcategory Form">
                    <dxo-header-filter [dataSource]="subcategoryFormNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="SubcategoryFunctionName" [visible]="false" caption="Subcategory Function">
                    <dxo-header-filter [dataSource]="subcategoryFunctionNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
            </dxi-column>

            <div *dxTemplate="let action of 'action'">
                <dx-button
                        id="btnReview"
                        class="mr-1"
                        *ngIf="action?.data?.ModifiedByUserId > 0 && action?.data?.ModifiedByUserId != currentUser?.UserId && action?.data?.ReviewedByUserId == -1"
                        icon="fas fa-check-double fa-1x"
                        hint="Review"
                        (onClick)="review(action?.data?.ProductBarcodeId)"
                ></dx-button>
                <dx-button *ngIf="currentUser?.UserRoleId > 1 && action?.data?.Active" icon="fas fa-trash-alt fa-1x" hint="Deactivate" (onClick)="deactivate(action?.data?.ProductBarcodeId)"></dx-button>
                <dx-button *ngIf="currentUser?.UserRoleId > 1 && !action?.data?.Active" icon="fas fa-trash-alt fa-1x" hint="Reactivate" (onClick)="reactivate(action?.data?.ProductBarcodeId)"></dx-button>
                <ng-container *ngIf="action?.data?.InconsistentServiceAndProductMappingsExist">
                    <dx-button
                            id="btnIsEligble"
                            class="ml-1"
                            icon="fas fa-concierge-bell fa-1x"
                            hint="Right-click for more"
                    ></dx-button>
<!--                    <i class="fas  text-xl" style="font-size: 1.25rem;" title=""></i>-->
                </ng-container>
            </div>
            <dxo-master-detail
                    [enabled]="true"
                    template="masterDetail"
            ></dxo-master-detail>

            <div *dxTemplate="let masterDetailItem of 'masterDetail'">
                <app-product-barcode-detail-view
                        [key]="masterDetailItem.key"
                ></app-product-barcode-detail-view>
            </div>
        </dx-data-grid>
    </div>
</div>

<div *ngIf="isLoadProductMasterWithSizeListGridSource">
    <div dragula="HANDLES3" id="left">
        <div class="mapping-grid-container shadow-lg mt-2">
            <span class="handle"><i class="fa fa-arrows" aria-hidden="true"></i></span>
            <div class="py-2 h-full">
                <dx-data-grid
                    #productBarcodeAssignmentToMasterGrid
                    id="productBarcodeAssignmentToMasterGrid"
                    [allowColumnResizing]="true"
                    [columnResizingMode]="'widget'"
                    [allowColumnReordering]="true"
                    [dataSource]="productBarcodeAssignmentToMasterGridDataSource"
                    [showBorders]="true"
                    [columnAutoWidth]="true"
                    [hoverStateEnabled]="true"
                    >
                    <dxo-load-panel
                            [enabled]="false"
                            shadingColor="rgba(0,0,0,0.4)"
                            [showIndicator]="true"
                            [showPane]="true"
                            [shading]="true">
                    </dxo-load-panel>
                    <dxo-selection mode="single"></dxo-selection>
                    <dxi-column dataField="AssignmentSource" caption="Assignments"></dxi-column>
                    <dxi-column caption="Action" cellTemplate="action" alignment="center"></dxi-column>
                    <dxi-column dataField="CleanBarcode" caption="Clean Barcode"></dxi-column>
                    <dxi-column dataField="IsValidBarcode" caption="Valid Barcode"></dxi-column>
                    <dxi-column dataField="IsVerifiedBarcode" caption="Verified Barcode"></dxi-column>
                    <dxi-column dataField="BarcodeMappingId" caption="Barcode Mapping ID" [visible]="false" [allowHeaderFiltering]="false" [width]="140" [customizeText]="customizeBarcodeMappingId"></dxi-column>
                    <dxi-column dataField="BarcodeMappingModeId" caption="Barcode Mapping Mode ID"></dxi-column>
                    <dxi-column dataField="BarcodeMappingModeName" caption="Barcode Mapping Mode"></dxi-column>
                    <dxi-column dataField="IsInconsistentProductMapping" caption="Inconsistent Product Mapping"></dxi-column>
                    <dxi-column dataField="ServiceAndProductMappingModeId" caption="Product Mapping Mode ID"></dxi-column>
                    <dxi-column dataField="ServiceAndProductMappingModeName" caption="Product Mapping Mode"></dxi-column>
                    <dxi-column dataField="ProductMasterId" caption="Product Master ID" [allowHeaderFiltering]="false" [width]="140" [customizeText]="customizeProductMasterId"></dxi-column>

                    <dxi-column dataField="CompanyName"></dxi-column>
                    <dxi-column dataField="MasterBrandName"></dxi-column>
                    <dxi-column dataField="BrandName"></dxi-column>
                    <dxi-column dataField="SubBrandName" caption="Sub-brand"></dxi-column>
                    <dxi-column dataField="ProductName" caption="Product"></dxi-column>
                    <dxi-column dataField="ProductIsNatureInspired"></dxi-column>
                    <dxi-column dataField="ProductIsMensProduct"></dxi-column>
                    <dxi-column dataField="CategoryName"></dxi-column>
                    <dxi-column dataField="SubcategoryFunctionName"></dxi-column>
                    <dxi-column dataField="SubcategoryFormName"></dxi-column>
                    <dxi-column dataField="ProductSizeOnLabel"></dxi-column>

                    <div *dxTemplate="let action of 'action'">
                        <dx-button
                                id="btnReassign"
                                *ngIf="
                                action?.data?.Ranking >= 0 &&
                                action?.data?.ProductMasterId != 0 &&
                                action?.data?.CurrentProductMasterId !== action?.data?.ProductMasterId &&
                                (
                                    action?.data?.BarcodeMappingModeId == 1 || action?.data?.ServiceAndProductMappingModeId == 1
                                )"
                                class="mr-1"
                                icon="fas fa-map-marker-alt fa-1x"
                                hint="Reassign"
                                (onClick)="reassign(action?.data?.ProductBarcodeId, action?.data?.ProductMasterId)"></dx-button>
                    </div>
                </dx-data-grid>
            </div>
        </div>
        <div class="mapping-grid-container shadow-lg mt-2">
            <span class="handle mr-3"><i class="fa fa-arrows" aria-hidden="true"></i></span>
            <div class="mt-2 h-full">
                <app-product-master-data-grid
                        masterGridName="productMasterDataGrid"
                        pageName="productBarcodeMapping"
                        [isCreateProduct]="isCreateProduct"
                        (productCreateModalClosed)="isCreateProduct = false"
                        (onProductMasterDataGridLoaded)="productMasterGridLoadingHandler($event)"
                        (productMappingSelectionChanged) = "productMappingSelectionChanged($event)"
                        (onMap)="assign($event)"
                ></app-product-master-data-grid>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <dx-button
            icon="close"
            text="Cancel"
            (onClick)="activeModal.dismiss('Cross click')"
    >
    </dx-button>
</div>
